import contractABI from "./abi.json";

const contractAddress = "0x53799Fd6997ac709BDA34F02cA51953EC104B876";

let web3 = new Web3(window.ethereum);
let contract = new web3.eth.Contract(contractABI, contractAddress);

async function connectWallet() {
    if (!window.ethereum) {
        console.error("No web3 provider detected");
        document.getElementById("connectMessage").innerText =
            "No web3 provider detected. Please install MetaMask.";
        return;
    }

    const accounts = await window.ethereum
        .request({ method: "eth_requestAccounts" })
        .catch((err) => {
            if (err.code === 4001) {
                console.log("Please connect to MetaMask.");
            } else {
                console.error(err);
            }
        });

    if (!accounts || !accounts[0]) return;
    setConnected(accounts[0]);
}

async function createTweet(content) {
    const accounts = await web3.eth.getAccounts();
    try {
        await contract.methods.createTweet(content).send({ from: accounts[0] });
        displayTweets(accounts[0]);
    } catch (error) {
        console.error("Create tweet error:", error);
        // Check for registration problem and show helpful message
        try {
            const profileAddr = await contract.methods.profileContract().call();
            document.getElementById("connectMessage").style.display = "block";
            document.getElementById("connectMessage").innerText =
                `Action failed. Make sure you registered a profile (Profile contract: ${profileAddr}).`;
        } catch (e) {
            document.getElementById("connectMessage").style.display = "block";
            document.getElementById("connectMessage").innerText =
                `Action failed: ${error.message || error}`;
        }
    }
}

async function displayTweets(userAddress) {
    const tweetsContainer = document.getElementById("tweetsContainer");
    tweetsContainer.innerHTML = "";
    const tempTweets = await contract.methods.getAllTweets(userAddress).call();
    const tweets = [...tempTweets];
    tweets.sort((a, b) => b.timestamp - a.timestamp);
    for (let i = 0; i < tweets.length; i++) {
        const tweetElement = document.createElement("div");
        tweetElement.className = "tweet";

        const userIcon = document.createElement("img");
        userIcon.className = "user-icon";
        userIcon.src = `https://avatars.dicebear.com/api/human/${tweets[i].author}.svg`;
        userIcon.alt = "User Icon";

        tweetElement.appendChild(userIcon);

        const tweetInner = document.createElement("div");
        tweetInner.className = "tweet-inner";

        tweetInner.innerHTML += `
        <div class="author">${shortAddress(tweets[i].author)}</div>
        <div class="content">${tweets[i].content}</div>
    `;

        const likeButton = document.createElement("button");
        likeButton.className = "like-button";
        likeButton.innerHTML = `
        <i class="far fa-heart"></i>
        <span class="likes-count">${tweets[i].likes}</span>
    `;
        likeButton.setAttribute("data-id", tweets[i].id);
        likeButton.setAttribute("data-author", tweets[i].author);

        addLikeButtonListener(
            likeButton,
            userAddress,
            tweets[i].id,
            tweets[i].author
        );
        tweetInner.appendChild(likeButton);
        tweetElement.appendChild(tweetInner);

        tweetsContainer.appendChild(tweetElement);
    }
}

function addLikeButtonListener(likeButton, address, id, author) {
    likeButton.addEventListener("click", async (e) => {
        e.preventDefault();

        const orig = likeButton.innerHTML;
        likeButton.innerHTML = '<div class="spinner"></div>';
        likeButton.disabled = true;
        try {
            await likeTweet(author, id);
            await displayTweets(address);
        } catch (error) {
            console.error("Error liking tweet:", error);
        } finally {
            likeButton.disabled = false;
            likeButton.innerHTML = orig;
        }
    });
}

function shortAddress(address, startLength = 6, endLength = 4) {
    return `${address.slice(0, startLength)}...${address.slice(-endLength)}`;
}

async function likeTweet(author, id) {
    try {
        const accounts = await web3.eth.getAccounts();
        await contract.methods.likeTweet(author, id).send({ from: accounts[0] });
    } catch (error) {
        console.error("User rejected request:", error);
        throw error;
    }
}

function setConnected(address) {
    document.getElementById("userAddress").innerText =
        "Connected: " + shortAddress(address);
    document.getElementById("connectMessage").style.display = "none";
    document.getElementById("tweetForm").style.display = "block";
    displayTweets(address);
}

document
    .getElementById("connectWalletBtn")
    .addEventListener("click", connectWallet);

document.getElementById("tweetForm").addEventListener("submit", async (e) => {
    e.preventDefault();
    const content = document.getElementById("tweetContent").value;
    const tweetSubmitButton = document.getElementById("tweetSubmitBtn");
    const orig = tweetSubmitButton.innerHTML;
    tweetSubmitButton.innerHTML = '<div class="spinner"></div>';
    tweetSubmitButton.disabled = true;
    try {
        await createTweet(content);
    } catch (error) {
        console.error("Error sending tweet:", error);
    } finally {
        tweetSubmitButton.innerHTML = orig;
        tweetSubmitButton.disabled = false;
    }
});
